/* eslint-disable no-unused-vars */
import { Store } from "./Store";

export const StringUtils = {
  strToDouble,
  formattedNumber,
  applyStandardPrintHeaders,
  inputValidation,
  formatDate,
  formattedNumberOptDecimal,
  convertStringAsNumber,
  formattedNumberWithStoreDecimal,
  getIsoDate,
};

function convertStringAsNumber(inputString, applyDecimal) {
  let decimaLength = JSON.parse(Store.get("decimal"));
  let len = inputString.length;

  if (len > decimaLength && applyDecimal) {
    let val =
      inputString.substring(0, len - decimaLength) +
      "." +
      inputString.substring(len - decimaLength, len);
    return parseFloat(val);
  }
  return parseFloat(inputString);
}

function strToDouble(inputString) {
  //var localStorageItem=localStorage.getItem("w_storeDetails");
  //console.log("Round values using "+localStorage.getItem("w_storeDetails").decimalPoints+" Deciaml poients");
  return inputString.toFixed(Store.get("decimal"));
  // /window.storeSetting.decimalPoints
}

function formattedNumber(inputString, decimal) {
  if (decimal) return parseFloat(inputString).toFixed(decimal);
  let val = parseFloat(inputString).toFixed(Store.get("decimal"));
  return val;
}

function formattedNumberWithStoreDecimal(inputString, context, decimal) {
  if (Store.get("decimal")) {
    return parseFloat(inputString).toFixed(Store.get("decimal"));
  } else if (
    context &&
    context.store.currencyDecimal &&
    context.store.currencyDecimal != ""
  ) {
    return parseFloat(inputString).toFixed(
      parseInt(context.store.currencyDecimal)
    );
  } else if (decimal) {
    return parseFloat(inputString).toFixed(decimal);
  } else {
    console.log("ERROR", "Parse failed, returning the same input value");
    return inputString;
  }
}

function formattedNumberOptDecimal(inputString) {
  //console.log(inputString);
  // var localStorageItem=localStorage.getItem("w_storeDetails");
  //console.log("Round values using "+localStorage.getItem("w_storeDetails").decimalPoints+" Deciaml poients");
  if (Number.isInteger(inputString)) {
    return parseInt(inputString);
  }

  return parseFloat(inputString).toFixed(Store.get("decimal"));
  //window.storeSetting.decimalPoints
}

function applyStandardPrintHeaders(data) {
  let data1 = JSON.parse(localStorage.getItem("w_storeDetails"));
  let user = JSON.parse(localStorage.getItem("w_userBean"));

  data["store"] = data1;
  data["user"] = user;
}

function inputValidation(
  inputValue,
  fieldType,
  isAlphanumeric,
  isNumber,
  isCharacter,
  isMaxlength,
  maxLength
) {
  let result = { status_value: true, status_message: "" };
  if (isAlphanumeric) {
    const regex = RegExp(/^[a-zA-Z0-9 ]*$/);
    if (!regex.test(inputValue)) {
      result = { status_value: false, status_message: "Invalid " + fieldType };
    }
  }
  if (isNumber) {
    const regex = RegExp(/[+-]?([0-9]*[.])?[0-9]+/);
    if (!regex.test(inputValue)) {
      result = { status_value: false, status_message: "Invalid " + fieldType };
    }
  }
  if (isCharacter) {
    const regex = RegExp(/^[a-zA-Z]+$/);
    if (!regex.test(inputValue)) {
      result = { status_value: false, status_message: "Invalid " + fieldType };
    }
  }
  if (isMaxlength) {
    if (inputValue.length > maxLength) {
      result = {
        status_value: false,
        status_message: fieldType + " should no exceed 100 characters",
      };
    }
  }
  return result;
}
function formatDate(dateObj, format) {
  var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  let val = "";
  var curr_date = dateObj.getDate();
  var curr_month = dateObj.getMonth();
  curr_month = curr_month + 1;
  var curr_year = dateObj.getFullYear();
  var curr_min = dateObj.getMinutes();
  var curr_hr = dateObj.getHours();
  var curr_sc = dateObj.getSeconds();
  if (curr_month.toString().length == 1) curr_month = "0" + curr_month;
  if (curr_date.toString().length == 1) curr_date = "0" + curr_date;
  if (curr_hr.toString().length == 1) curr_hr = "0" + curr_hr;
  if (curr_min.toString().length == 1) curr_min = "0" + curr_min;

  if (format == 1) {
    //dd-mm-yyyy
    val = curr_date + "-" + curr_month + "-" + curr_year;
  } else if (format == 2) {
    //yyyy-mm-dd
    val = curr_year + "-" + curr_month + "-" + curr_date;
  } else if (format == 3) {
    //dd/mm/yyyy
    val = curr_date + "/" + curr_month + "/" + curr_year;
  } else if (format == 4) {
    // MM/dd/yyyy HH:mm:ss
    val =
      curr_month +
      "/" +
      curr_date +
      "/" +
      curr_year +
      " " +
      curr_hr +
      ":" +
      curr_min +
      ":" +
      curr_sc;
  }
  return val;
}

function getIsoDate(date) {
  if (date && date.$d) {
    var targetTime = new Date(date.$d.getTime());
    targetTime.setHours(0);
    targetTime.setMinutes(0);
    var tzDifference = targetTime.getTimezoneOffset() * 2;
    var offsetTime = new Date(targetTime.getTime() - tzDifference * 60 * 1000);
    return offsetTime.toISOString();
  } else if (date) {
    var targetTime = new Date(date);
    targetTime.setHours(0);
    targetTime.setMinutes(0);
    var tzDifference = targetTime.getTimezoneOffset() * 2;
    var offsetTime = new Date(targetTime.getTime() - tzDifference * 60 * 1000);
    return offsetTime.toISOString();
  }
  return null;
}
